import { useValidateListOrder } from '../../filter';
import { useAccountListOrder } from './useAccountListOrder';
import { useSetAccountListOrder } from './useSetAccountListOrder';

export const useValidateAccountListOrder = () => {
  return useValidateListOrder(useAccountListOrder, useSetAccountListOrder);
};
